export const columns = [
  {
    title: 'Magazine finale',
    field: 'finalStores',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Depozite (Infolog)',
    field: 'warehouses',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Categorie marfă',
    field: 'cargoCategory',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Hub plecare',
    field: 'departureHub',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Hub sosire',
    field: 'arrivalHub',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Cod cursă',
    field: 'raceCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Număr camion',
    field: 'truckNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume şofer',
    field: 'driverName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Status livrare',
    field: 'deliveryStatus',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Locaţie',
    field: 'location',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data estimată de livrare',
    field: 'estimatedDeliveryDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume magazin sosire',
    field: 'arrivalStoreName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Cod magazin sosire',
    field: 'arrivalStoreCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Conformitate termodiagramă',
    field: 'thermodiagramCompliance',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Conformitate sigilii',
    field: 'sealCompliance',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Conformitate sosire',
    field: 'arrivalCompliance',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data înregistrării',
    field: 'registrationDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Bonuri de livrare',
    field: 'deliverySlips',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Dată sosire',
    field: 'arrivalDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Număr supporţi',
    field: 'supportNumber',
    align: 'left',
    type: 'string'
  },
]